module.exports = __webpack_public_path__ + "static/media/chevron-gauche-cercle.b9551e47.png";